import { WpViewTable } from '../../core';

function determineStrDate(value?: string): Date {
    if (value != null) {
        return new Date(`${value}T00:00:00.000`);
    }
    return null;
}

function determineStrDate2(value?: string): Date {
    if (value != null) {
        return new Date(
            value.trim().toLowerCase().endsWith('z') ? value : `${value}Z`,
        );
    }
    return null;
}

export function determinePeriod(table: WpViewTable): {
    start: Date;
    end: Date;
    createdOn: Date;
} {
    const row = table.rows?.[0]?.row;
    const start = determineStrDate(
        row?.individual?.startDateDataRange ??
            row?.peopleDetail?.startDateDataRange,
    );
    const end = determineStrDate(
        row?.individual?.endDateDataRange ??
            row?.peopleDetail?.endDateDataRange,
    );
    const createdOn = determineStrDate2(
        (row?.individual?.createdOn ??
            row?.peopleDetail?.createdOn) as any as string,
    );
    return { start, end, createdOn };
}
